const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecycleIrrigation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 146 130.23",
    style: {
      enableBackground: "new 0 0 146 130.23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 12,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M116.53,25.02C90.61,39.11,73,66.64,73,98.3v25.92c0-31.66-17.61-59.19-43.53-73.28 M135.25,31.29c2.52-5.78,4.18-11.89,4.72-17.78 c0.34-3.68-2.37-6.96-6.04-7.3C111.21,4.1,82.27,17.92,80.4,38.25c-0.34,3.69,0.43,7.22,2.18,10.57l3.18,4.6 c3.64,4.16,8,6.56,13.01,7.02c8.23,0.76,16.22-3.07,22.95-9.42 M63.42,74.47c1.75-3.34,2.52-6.87,2.18-10.57 c-1.87-20.32-30.82-34.14-53.53-32.04c-3.67,0.34-6.38,3.62-6.04,7.3c2.1,22.79,20.95,48.81,41.21,46.93 c5.01-0.47,9.37-2.86,13.01-7.02L63.42,74.47z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycleIrrigation);
export default __webpack_public_path__ + "static/media/recycle-irrigation.ff0056e6526c6d47ab72e1b84b2a0e5c.svg";
export { ForwardRef as ReactComponent };